import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocOnCallRedirectRoute: InvariantJiraRoute = {
	name: 'eoc-on-call-redirect',
	path: '/jira/ops/teams/:teamId',
	exact: true,
};
